import React from 'react';
import {Field, FieldArray} from 'redux-form';
import SalaryTypeSelect from './SalaryTypeSelect.js';
import CheckStubArrayForm from './CheckStubArrayForm.js';

const WorkDependenceForm = (props) => {
	const salary_types = [{ id:0, name:'Mensual'}, {id:1, name:'Quincenal'}]
	return	(<div>
			<div className="row">
			    <div className="col-sm-12 col-md-4 col-lg-4">
			        <div className="form-group">
			            <Field className="form-control" name="salary_type" component={SalaryTypeSelect} options={salary_types} type="select"/>
			        </div>
			    </div>
			</div>
			<FieldArray name="check_stubs" component={CheckStubArrayForm} props={{deleteReduxFormField: props.deleteReduxFormField}}/>
		</div>
	);
}

export default WorkDependenceForm;


/** WEBPACK FOOTER **
 ** ./src/components/WorkDependenceForm.js
 **/